import { render } from "./PreviousIllustrations.vue?vue&type=template&id=577e2088"
import script from "./PreviousIllustrations.vue?vue&type=script&lang=js"
export * from "./PreviousIllustrations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__